import { useContext, createContext, useState, useCallback, useMemo } from 'react';
import { RowDiv, Text } from 'styles';
import { Icon } from 'components/common/Icon';
import { Button } from 'components/button/Button';
import { Dim } from 'components';
import ModalContainer from 'components/dialogs/ModalContainer';

const AlertContext = createContext({
  alert: () => {},
  toggleAlert: () => {}
});

export function AlertContextProvider({ children }) {

  const [open, setOpen] = useState(false);
  const [dialogState, setDialogState] = useState({
    type: 'alert',
    title: 'Info',
    content: '',
    okCallback: () => {},
    cancelCallback: () => {},
  });

  const alert = useCallback((dialogState) => {
    toggleAlert(true);
    const closeAlert = () => toggleAlert(false);

    const okCallback = () => {
      if (dialogState.okCallback) {
        dialogState.okCallback();
      }

      closeAlert();
    }

    const cancelCallback = () => {
      if (dialogState.cancelCallback) {
        dialogState.cancelCallback();
      }

      closeAlert();
    }

    setDialogState({ ...dialogState, okCallback: okCallback, cancelCallback: cancelCallback });
  }, []);

  const toggleAlert = useCallback((value) => {
    setOpen((prevState) => value ?? !prevState);
  }, []);

  const value = useMemo(() => {
    const val = {
      alert,
      toggleAlert
    };

    return val;
  }, [alert, toggleAlert]);

  return (
    <AlertContext.Provider value={value}>
      {children}

      <Dim open={open}>
        <ModalContainer>
          <div className="title">
            <Icon name="Info" $pathFill="primary100" />
            <Text $type="m18" $color="normal">
              {dialogState.title}
            </Text>
          </div>
          <div className="con">
            <div dangerouslySetInnerHTML={{ __html: dialogState.content || '' }}>
            </div>
            <RowDiv $marginTop={32} $gap={8} $justifyContent="flex-end">
              { dialogState.type ==='alert' &&
                <Button $size="default" onClick={dialogState.okCallback ? dialogState.okCallback : () => {toggleAlert(false)}}>
                  확인
                </Button>
              }
              { dialogState.type ==='confirm' &&
                <>
                  <Button $size="default" $type="sub" onClick={dialogState.cancelCallback ? dialogState.cancelCallback : () => {toggleAlert(false)}}>
                    취소
                  </Button>
                  <Button $size="default" onClick={dialogState.okCallback ? dialogState.okCallback : () => {toggleAlert(false)}}>
                    확인
                  </Button>
                </>
              }
            </RowDiv>
          </div>
        </ModalContainer>
      </Dim>

      {/* <Dialog open={open} handler={dialogState.cancelCallback ? dialogState.cancelCallback : () => {toggleAlert(false)}}>
        <DialogHeader>{dialogState.title}</DialogHeader>
        <DialogBody>
          <div dangerouslySetInnerHTML={{ __html: dialogState.content || '' }}>
          </div>
        </DialogBody>
        { dialogState.type ==='alert' &&
          <DialogFooter>
            <Button onClick={dialogState.okCallback ? dialogState.okCallback : () => {toggleAlert(false)}}>
              <span>{t('ok')}</span>
            </Button>
          </DialogFooter>
        }
        { dialogState.type ==='confirm' &&
          <DialogFooter>
            <Button
              variant="outlined"
              onClick={dialogState.cancelCallback ? dialogState.cancelCallback : () => {toggleAlert(false)}}
              className="mr-1"
            >
              <span>{t('Cancel')}</span>
            </Button>
            <Button onClick={dialogState.okCallback ? dialogState.okCallback : () => {toggleAlert(false)}}>
              <span>{t('ok')}</span>
            </Button>
          </DialogFooter>
        }
        
      </Dialog> */}
    </AlertContext.Provider>
  );
}

export function useAlertContext() {
  return useContext(AlertContext);
}

export default useAlertContext;